import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import TestimonialsPanel from '../TestimonialsPanel'
import WhyDoWeChargeAFee from '../WhyDoWeChargeAFee'
import Cookies from 'universal-cookie'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import { getCurrencySign } from '../../utils/utils'
import { shouldTranslateTo } from '../../utils/utils'
import verifyAccountStatus from '../Hooks/VerifyAccountStatus'
import moment from 'moment'
import {
  Input,
  Title,
  Subtitle,
  ActionButtons,
  LoadingButton,
} from '../Utils/CustomClasses'
import { scrollIntoView } from '../Hooks/ScrollView'

const cookies = new Cookies()

const ContainerBox = styled.div`
  padding: 0 36px 55px 36px;
  background-color: transparent;

  @media (max-width: 767px) {
    padding: 25px 25px 25px 25px;
  }
`

const Center = styled.div`
  text-align: center;
  margin-top: 40px;
`

const CenterSmallMargin = styled(Center)`
  margin: 50px auto 50px;
`

const OnboardingTitle = styled(Title)`
  font-family: 'Open Sans', sans-serif;
`

const OnboardingTitleBottom = styled(OnboardingTitle)`
  margin: 40px auto 40px auto;
`

const OnboardingSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
`

const OnboardingSubtitleDiscount = styled(OnboardingSubtitle)`
  background-color: #ffff00;
  border-radius: 5px;
  padding: 10px;
  color: #000;

  span {
    color: #ff0000;
  }
`

const PriceChoiceSubtitle = styled(Subtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;
  font-size: 18px;
  margin: 24px 20px 30px 20px;

  @media (max-width: 799px) {
    font-size: 18px !important;
  }
`

const PriceInfoSubtitle = styled(Subtitle)`
  color: #5a5a5a;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  letter-spacing: 0px;
  margin: 0 auto 30px auto;
  max-width: 340px;

  b {
    color: #06944d;
    font-weight: 700;
  }

  span {
    color: #ff0000;
    font-weight: 700;
    text-decoration: line-through;
  }

  @media (max-width: 799px) {
    font-size: 17px !important;
    width: 210px;
  }

  @media (max-width: 499px) {
    width: 100%;
  }
`

const FlexRowPrice = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: 60px;

  & > div {
    flex-basis: 50%;
  }

  @media (min-width: 1024px) {
    max-width: 850px;
    margin: 20px auto 0 auto;
  }

  @media (max-width: 799px) {
    flex-direction: column;
    max-width: 400px;
    margin: 20px auto 0 auto;

    & > div {
      width: -webkit-fill-available;
    }
  }
`

const FlexRowPriceInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 20px;

  & > div {
    flex-basis: 100%;
  }

  @media (max-width: 799px) {
    flex-direction: column;

    & > div {
      width: -webkit-fill-available;
    }
  }
`

const PriceBox = styled.div`
  background-color: #fff;
  /*
  box-shadow: ${(props) => (props.shadow ? '0 5px 9px -2px #b5b5b5;' : 'none')};
  border: 1px solid #a5a5a5;
  */
  border-radius: 10px;
  overflow: hidden;
  min-height: 300px;
`

const PriceBoxHeader = styled.div`
  background-color: #000a84;
  padding: 6px;
`

const PriceBoxHeaderBadgeContainer = styled.div`
  position: relative;
`

const PriceBoxHeaderBadge = styled.div`
  background-color: #9b0000;
  border-radius: 50%;
  height: 90px;
  width: 90px;
  padding: 4px 0 0 0;
  position: absolute;
  top: -26px;
  right: -10px;
`

const PriceHeaderSubtitle = styled(Subtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;
`

const PriceHeaderBadgeSubtitle = styled(PriceHeaderSubtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-size: 19px;
  font-weight: 400;
  line-height: 126%;
  margin: 16px 0 0;
`

const PriceBoxPrice = styled.div`
  border-bottom: 1px solid #a5a5a5;
  align-items: center;
  justify-content: center;
`

const PriceContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 30px auto 34px;
  width: 170px;
  position: relative;
`

const PriceSubtitle = styled(Subtitle)`
  color: #000;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  letter-spacing: -1px;
  margin: 0 16px 0 0;

  @media (max-width: 799px) {
    font-size: 50px !important;
  }
`

const PriceSubtitleStrike = styled(Subtitle)`
  color: #ff0000;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  letter-spacing: -1px;
  position: absolute;
  top: -20px;
  font-size: 20px;
  text-decoration: line-through;
`

const PriceSubtitleNoStrike = styled(PriceSubtitleStrike)`
  text-decoration: none;
`

const PriceSubtitleNoStrikeSub = styled(PriceSubtitleNoStrike)`
  color: #6a6a6a;
  font-weight: 400;
  font-size: 13px;
  margin: 30px 0 0 0;
  width: 100%;
`
const PriceSubtitleNoStrikePrice = styled(PriceSubtitle)`
  margin: 20px 16px 0 0;
`

const PriceFreeSubtitle = styled(PriceSubtitle)`
  margin: 0;
`

const CurrencySubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-size: 23px;
  font-weight: 400;
  margin: -36px 4px 0 0;
`

const CurrencySubtitleNoStrike = styled(CurrencySubtitle)`
  margin: -16px 4px 0 0;
`

const PriceDurationSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  color: ${(props) => (props.color ? props.color : '#6a6a6a')};
  font-weight: 600;
  letter-spacing: 0px;
  margin: 0 0 0 2px;

  @media (max-width: 799px) {
    font-size: 14px !important;
  }
`

const PriceBoxInfo = styled.div`
  padding: 20px;
  align-items: center;
  justify-content: center;
  text-align: center;

  img {
    margin: 0 auto 20px;
    width: 100%;
    max-width: 170px;
  }
`

const ChoiceButton = styled(ActionButtons)`
  background-color: #0bac5d;
  width: -webkit-fill-available;
`

const ChoiceLoadingButton = styled(LoadingButton)`
  background-color: #0bac5d;
  width: -webkit-fill-available;
  padding: 10px 30px;
`

const ChoiceLoadingButtonInactive = styled(ChoiceButton)`
  background-color: #fff;
  cursor: default !important;
`

const TestimonialsWrapper = styled.div`
  margin: 0;
`

const PriceBoxList = styled.ul`
  margin: 0 1vw 40px;
  color: #fff;
  font-size: 22px;
  line-height: 25px;
  max-width: 450px;
  margin: 0 auto;

  @media screen and (max-width: 799px) {
    margin: 0 7vw 40px;
  }
`

const PriceBoxListIcon = styled.div`
  margin: 0 auto 40px;

  img {
    margin-bottom: 20px;
    width: 200px;
  }

  @media screen and (max-width: 799px) {
    margin: 0 7vw 40px;
  }
`

const PblI = styled.li`
  margin: 0 0 24px 20px;
  position: relative;

  &::before {
    content: url('images/onboarding/tick-green.svg');

    position: absolute;
    left: -32px;
    top: 1px;
    width: 24px;
  }
`

const PblIn = styled(PblI)`
  &::before {
    content: url('images/onboarding/cross-red.svg');
  }
`

const FlexRowDiscount = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-start;
  justify-content: center;
  font-size: 16px;
  margin: 0 0 40px 0;
`

const DiscountSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  margin: 80px 20px 8px 0;

  @media (max-width: 799px) {
    font-size: 18px !important;
  }
`

const DiscountInput = styled(Input)`
  margin: 0 0 10px 0;
  max-width: 417px;
`

const DiscountButton = styled(ActionButtons)`
  background-color: #0171d5;
  padding: 8px 30px;
`

const DiscountLoadingButton = styled(LoadingButton)`
  background-color: #0171d5;
  padding: 13px 30px;
`

const DiscountMessageSubtitle = styled(Subtitle)`
  background-color: #ffff00;
  color: #000;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  margin: 5px 20px 8px 0;
  padding: 5px 12px;
  border-radius: 6px;

  span {
    color: #ff0000;
  }

  @media (max-width: 799px) {
    font-size: 18px !important;
    margin: 5px 0 8px 0;
  }
`

const DiscountErrorMessageSubtitle = styled(DiscountMessageSubtitle)`
  color: #ff0000;
`

const ChooseSubscriptionOnboardingMonthly = ({ data, onComplete }) => {
  const [currencySign, setCurrencySign] = useState('')
  const [pageText, setPageText] = useState([])
  const [pageText2, setPageText2] = useState([])
  const [loading, setLoading] = useState('')
  const [membershipFees, setMembershipFees] = useState([4.99, 44.99])
  const [discountMessage, setDiscountMessage] = useState('')
  const [discountCode, setDiscountCode] = useState('')
  const [discounted, setDiscounted] = useState(false)
  const [discountAmount, setDiscountAmount] = useState('')
  const [discountType, setDiscountType] = useState('')
  const [monthlyDivisor, setMonthlyDivisor] = useState([3, 12])
  const [discountLoading, setDiscountLoading] = useState(false)
  const [discountErrorMessage, setDiscountErrorMessage] = useState('')
  const [originalMembershipFeeMonthly, setOriginalMembershipFeeMonthly] =
    useState('4.99')
  const [originalMembershipFeeAnnual, setOriginalMembershipFeeAnnual] =
    useState('44.99')
  const [membershipFeeMonthly, setMembershipFeeMonthly] = useState('4.99')
  const [membershipFeeAnnual, setMembershipFeeAnnual] = useState('44.99')
  const [discountMembershipFeeMonthly, setDiscountMembershipFeeMonthly] =
    useState('4.99')
  const [discountMembershipFeeAnnual, setDiscountMembershipFeeAnnual] =
    useState('44.99')
  const [discountMembershipFee, setDiscountMembershipFee] = useState('4.99')

  const leftRef = useRef(null)
  const rightRef = useRef(null)

  const leftRefTop = useRef(null)
  const rightRefTop = useRef(null)

  useEffect(() => {
    setTimeout(function () {
      //scrollIntoView(actionRef)
    }, 1000)
  }, [])

  useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          pageValue === 'profile-pay'
            ? setPageText(pageText)
            : setPageText2(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    const getCurrency = async () => {
      const currencySignData = await getCurrencySign(
        data.auth.user.currencyValue
      )
      setCurrencySign(currencySignData.sign)
    }
    getCurrency()

    data.auth.user.subscriptionType = null

    getPageText('profile-pay', language)
    getPageText('homepage-v2', language)
  }, [])

  useEffect(() => {
    const userData = cookies.get('uD')

    console.log('==============================')
    console.log('userData: ' + JSON.stringify(userData))

    if (userData) {
      if (userData.preDiscountMembershipFee !== 0) {
        console.log('triggered...')
        console.log(
          'userData.voucherCode: ' + JSON.stringify(userData.voucherCode)
        )
        handleApplyDiscount(userData.voucherCode)
      }
    }
  }, [pageText])

  const handleUpdateCode = (e) => {
    setDiscountLoading(false)
    setDiscountMessage('')
    setDiscountErrorMessage('')
    setDiscountCode(e)
  }

  const handleApplyDiscount = (voucherCode) => {
    console.log('handleApplyDiscount...')
    setDiscountErrorMessage('')
    console.log('discountCode: ' + discountCode)
    console.log('voucherCode: ' + voucherCode)

    var localDiscountCode = ''

    if (voucherCode != '0') {
      localDiscountCode = voucherCode
      setDiscountCode(voucherCode)
    } else {
      localDiscountCode = discountCode
    }

    if (localDiscountCode) {
      console.log('discountCode exists.')
      setDiscountLoading(true)
      axios
        .get(`api/discount-voucher/${localDiscountCode}`)
        .then((response) => {
          console.log('response' + JSON.stringify(response))

          if (Object.keys(response.data).length > 0) {
            if (
              moment() >= moment(response.data.startDate) &&
              moment() <= moment(response.data.endDate).add(1, 'days')
            ) {
              setDiscounted(true)
              setDiscountAmount(response.data.discountAmount)
              setDiscountType(response.data.discountUnit)

              let discountedFeeCalculated = 0.0

              if (response.data.discountUnit === 'PER') {
                const discountedFeeCalculatedMonthly = (
                  parseFloat(membershipFeeMonthly).toFixed(2) -
                  (
                    parseFloat(membershipFeeMonthly).toFixed(2) *
                      (response.data.discountAmount / 100) +
                    0.0001
                  ).toFixed(2)
                ).toFixed(2)
                setDiscountMembershipFeeMonthly(discountedFeeCalculatedMonthly)

                const discountedFeeCalculatedAnnual = (
                  parseFloat(membershipFeeAnnual).toFixed(2) -
                  (
                    parseFloat(membershipFeeAnnual).toFixed(2) *
                      (response.data.discountAmount / 100) +
                    0.0001
                  ).toFixed(2)
                ).toFixed(2)
                setDiscountMembershipFeeAnnual(discountedFeeCalculatedAnnual)

                setDiscountMessage(
                  pageText[48] +
                    ' <strong><span>' +
                    localDiscountCode +
                    '</span></strong> ' +
                    pageText[49] +
                    ' <strong><span>' +
                    response.data.discountAmount +
                    '%</span></strong>.'
                )
              } else if (response.data.discountUnit === 'MTH') {
                discountedFeeCalculated = membershipFeeMonthly
                setDiscountMembershipFee(discountedFeeCalculated)

                setDiscountMessage(
                  'Offer code <span><strong>' +
                    localDiscountCode +
                    '</strong></span> has been added. If you choose the monthly option your subscription will be ' +
                    ' <span><strong>' +
                    'free for the first ' +
                    response.data.discountAmount +
                    ' months' +
                    '</span></strong>. To continue with membership you still need to enter payment details, but rest assured <span><strong>you will not be charged for the first ' +
                    response.data.discountAmount +
                    ' months</span></strong>, and can cancel anytime.'
                )

                cookies.set('dtd', true, { path: '/' })
                cookies.set('dtdoamt', discountedFeeCalculated, { path: '/' })

                setTimeout(function () {
                  handleResizeColumns()
                }, 1000)
              }
            } else {
              setDiscountErrorMessage(pageText[50])
              setDiscounted(false)
            }
          } else {
            setDiscountErrorMessage(pageText[50])
            setDiscounted(false)
          }
        })
        .catch((err) => {
          console.log('Error getting discount code: ', err)
          setDiscounted(false)
        })
        .finally(() => {
          setDiscountLoading(false)
        })
    } else {
      setDiscountErrorMessage(pageText[51])
      setDiscounted(false)
      setDiscountLoading(false)
    }
  }

  useEffect(() => {
    function handleResize() {
      handleResizeColumns()
    }
    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  useEffect(() => {
    if (
      currencySign &&
      pageText.length !== 0 &&
      data.auth.user.membershipFeeStatus !== 'completed'
    ) {
      handleResizeColumns()
    }
  }, [currencySign, pageText])

  const handleResizeColumns = () => {
    if (
      !leftRef.current ||
      !rightRef.current ||
      !leftRefTop.current ||
      !rightRefTop.current
    )
      return

    leftRef.current.style.minHeight = `auto`
    rightRef.current.style.minHeight = `auto`
    leftRefTop.current.style.minHeight = `auto`
    rightRefTop.current.style.minHeight = `auto`

    const leftHeight = leftRef.current.getBoundingClientRect().height
    const rightHeight = rightRef.current.getBoundingClientRect().height
    const leftTopHeight = leftRefTop.current.getBoundingClientRect().height
    const rightTopHeight = rightRefTop.current.getBoundingClientRect().height

    if (leftHeight >= rightHeight) {
      rightRef.current.style.minHeight = `${leftHeight}px`
    } else {
      leftRef.current.style.minHeight = `${rightHeight}px`
    }

    if (leftTopHeight >= rightTopHeight) {
      rightRefTop.current.style.minHeight = `${leftTopHeight}px`
    } else {
      leftRefTop.current.style.minHeight = `${rightTopHeight}px`
    }
  }

  const handleSetPriceButton = (e, fee, option) => {
    e.preventDefault()

    console.log('option: ' + JSON.stringify(option))

    var membershipFee = 0.0
    var userData = {}

    setLoading(option)

    cookies.set('dtd', true, { path: '/' })

    if (discounted) {
      if (option === 'monthly') {
        membershipFee = discountMembershipFeeMonthly
        cookies.set('dtdoamt', discountMembershipFeeMonthly, { path: '/' })
        cookies.set(
          'dtdoamtmnth',
          discountMembershipFeeMonthly / monthlyDivisor[0],
          {
            path: '/',
          }
        )
      } else if (option === 'annual') {
        if (discountType === 'MTH') {
          membershipFee = membershipFeeAnnual
        } else {
          membershipFee = discountMembershipFeeAnnual
          cookies.set('dtdoamt', discountMembershipFeeAnnual, { path: '/' })
          cookies.set(
            'dtdoamtmnth',
            discountMembershipFeeAnnual / monthlyDivisor[1],
            {
              path: '/',
            }
          )
        }
      }

      var preDiscountMembershipFee = 0
      var originalMembershipFee = 0
      var discountAmountVal = null
      var discountTypeVal = null
      var dicountCodeVal = null

      if (option === 'monthly') {
        originalMembershipFee = membershipFeeMonthly
        preDiscountMembershipFee = membershipFeeMonthly
        discountAmountVal = discountAmount
        discountTypeVal = discountType
        dicountCodeVal = discountCode
      } else if (option === 'annual') {
        if (discountType === 'MTH') {
          originalMembershipFee = membershipFeeAnnual
          preDiscountMembershipFee = 0
        } else {
          originalMembershipFee = membershipFeeAnnual
          preDiscountMembershipFee = membershipFeeAnnual
          discountAmountVal = discountAmount
          discountTypeVal = discountType
          dicountCodeVal = discountCode
        }
      }

      userData = {
        originalMembershipFee: originalMembershipFee,
        preDiscountMembershipFee: preDiscountMembershipFee,
        membershipFee: membershipFee,
        subscriptionType: option,
        discount: discountAmountVal,
        discountType: discountTypeVal,
        voucherCode: dicountCodeVal,
      }
    } else {
      if (option === 'monthly') {
        membershipFee = membershipFees[0].toFixed(2)
      } else if (option === 'annual') {
        membershipFee = membershipFees[1].toFixed(2)
      }

      userData = {
        preDiscountMembershipFee: 0,
        membershipFee: membershipFee,
        subscriptionType: option,
        discount: null,
        discountType: null,
        voucherCode: null,
      }
    }

    console.log('userData: ' + JSON.stringify(userData))

    cookies.set('uD', userData, { path: '/' })

    setTimeout(function () {
      onComplete('mp')
      setLoading('')
    }, 1000)
  }

  if (!currencySign || pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border onboarding-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[10]}</span>
        </div>
      </div>
    )
  }
  return (
    <div className="container">
      <div className="row justify-content-center">
        <ContainerBox>
          {data.auth.user.membershipFeeStatus === 'completed' ? (
            <>
              <Title
                center
                color="#fff"
                size="29px"
                sizemd="29px"
                sizesm="24px"
                margin="0 0 20px 0"
                dangerouslySetInnerHTML={{
                  __html: `Membership plan : ${data.auth.user.subscriptionType === 'freemium' ? 'Visitor' : 'Paying member'}`,
                }}
              ></Title>
              <Subtitle
                center
                color="#fff"
                weight="400"
                size="20px"
                margin="20px 0 20px 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[12]} ${currencySign}${(Math.round(data.auth.user.membershipFee * 100) / 100).toFixed(2)}`,
                }}
              />
            </>
          ) : (
            <div>
              <OnboardingTitle
                center
                color="#ff9900"
                size="34px"
                sizemd="34px"
                sizesm="34px"
                margin="10px 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[57]}`,
                }}
              ></OnboardingTitle>

              <OnboardingSubtitle
                center
                color="#fff"
                size="20px"
                sizesm="20px"
                weight="700"
                margin="20px 0 30px"
                dangerouslySetInnerHTML={{
                  __html: `Freebird operates as a paid membership club, which underpins the security, trust and authenticity of our community, as well as funding the development of the platform.`,
                }}
              />

              <Subtitle
                center
                color="#ffffff"
                weight="400"
                size="21px"
                sizemd="1.25rem"
                sizesm="22px"
                margin="0 0 50px 0"
                dangerouslySetInnerHTML={{
                  __html: `We have 2 different membership plans to choose from, as best suits your needs: Monthly and Annual`,
                }}
              />

              <FlexRowPrice>
                <PriceBoxHeaderBadgeContainer>
                  <PriceBox>
                    <PriceBoxHeader>
                      {' '}
                      <PriceHeaderSubtitle
                        center
                        size="18px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `Monthly`,
                        }}
                      />
                    </PriceBoxHeader>
                    <PriceBoxPrice ref={leftRefTop}>
                      <PriceContainer>
                        {discounted ? (
                          discountType !== 'MTH' ? (
                            <>
                              <PriceSubtitleStrike
                                center
                                size="50px"
                                margin="0"
                                dangerouslySetInnerHTML={{
                                  __html: `${currencySign}${membershipFees[0].toFixed(2)}`,
                                }}
                              />
                              <CurrencySubtitle
                                center
                                size="16px"
                                margin="0"
                                dangerouslySetInnerHTML={{
                                  __html: `${currencySign}`,
                                }}
                              />
                              <PriceSubtitle
                                center
                                size="50px"
                                margin="0"
                                dangerouslySetInnerHTML={{
                                  __html: `${discountMembershipFeeMonthly}`,
                                }}
                              />
                            </>
                          ) : (
                            <>
                              <PriceSubtitleNoStrike
                                center
                                size="50px"
                                margin="0"
                                dangerouslySetInnerHTML={{
                                  __html: `${discountAmount} MONTHS FREE`,
                                }}
                              />
                              <PriceSubtitleNoStrikeSub
                                center
                                size="13px"
                                margin="0"
                                dangerouslySetInnerHTML={{
                                  __html: `THEN`,
                                }}
                              />
                              <CurrencySubtitleNoStrike
                                center
                                size="16px"
                                margin="0"
                                dangerouslySetInnerHTML={{
                                  __html: `${currencySign}`,
                                }}
                              />
                              <PriceSubtitleNoStrikePrice
                                center
                                size="50px"
                                margin="0"
                                dangerouslySetInnerHTML={{
                                  __html: `${membershipFees[0].toFixed(2)}`,
                                }}
                              />
                            </>
                          )
                        ) : (
                          <>
                            <CurrencySubtitle
                              center
                              size="16px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${currencySign}`,
                              }}
                            />
                            <PriceSubtitle
                              center
                              size="50px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${membershipFees[0].toFixed(2)}`,
                              }}
                            />
                          </>
                        )}

                        <PriceDurationSubtitle
                          center
                          size="13px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `EVERY MONTH`,
                          }}
                        />
                      </PriceContainer>
                    </PriceBoxPrice>
                    <PriceBoxInfo ref={leftRef}>
                      <PriceBoxListIcon>
                        {' '}
                        <img src={'images/onboarding/icon-coffee-solo.svg'} />
                        <PriceInfoSubtitle
                          center
                          size="18px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${pageText[72]}`,
                          }}
                        />
                      </PriceBoxListIcon>
                      {loading === 'monthly' ? (
                        <ChoiceLoadingButton
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                          onClick={(e) => {
                            handleSetPriceButton(
                              e,
                              membershipFees[0].toFixed(2),
                              'monthly'
                            )
                          }}
                        >
                          {pageText[30]}
                        </ChoiceLoadingButton>
                      ) : (
                        <ChoiceButton
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                          onClick={(e) => {
                            handleSetPriceButton(
                              e,
                              membershipFees[0].toFixed(2),
                              'monthly'
                            )
                          }}
                        >
                          {pageText[30]}
                        </ChoiceButton>
                      )}
                    </PriceBoxInfo>
                  </PriceBox>
                </PriceBoxHeaderBadgeContainer>

                <PriceBoxHeaderBadgeContainer>
                  <PriceBoxHeaderBadge>
                    {' '}
                    <PriceHeaderBadgeSubtitle
                      center
                      size="28px"
                      margin="0"
                      dangerouslySetInnerHTML={{
                        __html: `Best<br/>value`,
                      }}
                    />
                  </PriceBoxHeaderBadge>
                  <PriceBox>
                    <PriceBoxHeader>
                      {' '}
                      <PriceHeaderSubtitle
                        center
                        size="18px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `Annual`,
                        }}
                      />
                    </PriceBoxHeader>
                    <PriceBoxPrice ref={rightRefTop}>
                      <PriceContainer>
                        {discounted && discountType !== 'MTH' ? (
                          <>
                            <PriceSubtitleStrike
                              center
                              size="50px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${currencySign}${membershipFees[1].toFixed(2)}`,
                              }}
                            />
                            <CurrencySubtitle
                              center
                              size="16px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${currencySign}`,
                              }}
                            />
                            <PriceSubtitle
                              center
                              size="50px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${discountMembershipFeeAnnual}`,
                              }}
                            />
                          </>
                        ) : (
                          <>
                            <CurrencySubtitle
                              center
                              size="16px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${currencySign}`,
                              }}
                            />
                            <PriceSubtitle
                              center
                              size="50px"
                              margin="0"
                              dangerouslySetInnerHTML={{
                                __html: `${membershipFees[1].toFixed(2)}`,
                              }}
                            />
                          </>
                        )}

                        <PriceDurationSubtitle
                          center
                          size="13px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${pageText[33]}`,
                          }}
                        />
                      </PriceContainer>
                    </PriceBoxPrice>
                    <PriceBoxInfo ref={rightRef}>
                      <PriceBoxListIcon>
                        {' '}
                        <img
                          src={'images/onboarding/icon-annual-connections.svg'}
                        />
                        <PriceInfoSubtitle
                          center
                          size="18px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `Ideal for the avid traveller, an annual membership offers you more time to build meaningful connections,
                                    plan trips, organise meetups and more with fellow Freebird Club members.<br/><b>Equivalent to 3 months free</b>`,
                          }}
                        />
                      </PriceBoxListIcon>
                      {loading === 'annual' ? (
                        <ChoiceLoadingButton
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                          onClick={(e) => {
                            handleSetPriceButton(
                              e,
                              membershipFees[1].toFixed(2),
                              'annual'
                            )
                          }}
                        >
                          {pageText[30]}
                        </ChoiceLoadingButton>
                      ) : (
                        <ChoiceButton
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                          onClick={(e) => {
                            handleSetPriceButton(
                              e,
                              membershipFees[1].toFixed(2),
                              'annual'
                            )
                          }}
                        >
                          {pageText[30]}
                        </ChoiceButton>
                      )}
                    </PriceBoxInfo>
                  </PriceBox>
                </PriceBoxHeaderBadgeContainer>
              </FlexRowPrice>

              <DiscountSubtitle
                center
                color="#fff"
                size="18px"
                margin="40px 0 6px 0px"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[52]}:`,
                }}
              />

              <FlexRowDiscount>
                {' '}
                <DiscountInput
                  id="discountcode"
                  type="text"
                  name="discountcode"
                  value={discountCode}
                  placeholder={pageText[54]}
                  onChange={(e) => handleUpdateCode(e.target.value)}
                />
                {discountLoading ? (
                  <DiscountLoadingButton
                    padding="10px 30px"
                    onClick={() => {
                      handleApplyDiscount('0')
                    }}
                  ></DiscountLoadingButton>
                ) : (
                  <DiscountButton
                    padding="10px 30px"
                    onClick={() => {
                      handleApplyDiscount('0')
                    }}
                  >
                    {pageText[53]}
                  </DiscountButton>
                )}
              </FlexRowDiscount>
              {discountMessage && (
                <DiscountMessageSubtitle
                  size="16px"
                  dangerouslySetInnerHTML={{
                    __html: `${discountMessage}`,
                  }}
                />
              )}
              {discountErrorMessage && (
                <DiscountErrorMessageSubtitle
                  size="16px"
                  dangerouslySetInnerHTML={{
                    __html: `${discountErrorMessage}`,
                  }}
                />
              )}

              <FlexRowPriceInfo>
                <OnboardingTitleBottom
                  center
                  color="#ff9900"
                  size="29px"
                  sizemd="29px"
                  sizesm="29px"
                  margin="10px 0 0"
                  dangerouslySetInnerHTML={{
                    __html: `What Freebird Club Membership entails:`,
                  }}
                ></OnboardingTitleBottom>
                <PriceBoxList>
                  <PblI>Get travel tips & advice from members</PblI>
                  <PblI>Arrange meet-ups with locals</PblI>
                  <PblI>Find travel buddies to go on trips with</PblI>
                  <PblI>Book or host friendly homestays</PblI>
                  <PblI>Participate in group events</PblI>
                  <PblI>Special offers from tourism partners</PblI>
                </PriceBoxList>
              </FlexRowPriceInfo>

              <CenterSmallMargin>
                <img
                  src="/images/onboarding/licensePaypal.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-app3"
                />
                <img
                  src="/images/onboarding/licensePaypal-mobile2.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-mobile-app3"
                />
              </CenterSmallMargin>

              <PriceChoiceSubtitle
                center
                size="28px"
                margin="0 0 10px 1%"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[22]}`,
                }}
              />

              <PriceChoiceSubtitle
                center
                size="28px"
                margin="0 0 10px 1%"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[23]}`,
                }}
              />

              {/* Testimonials */}
              <TestimonialsWrapper>
                <TestimonialsPanel
                  color="transparent"
                  textcolor="#fff"
                  showintro={true}
                  numbertoshow={10}
                />
              </TestimonialsWrapper>

              {/* Trust & Security / ID */}
              <WhyDoWeChargeAFee
                pageText={pageText}
                pageText2={pageText2}
                color={'transparent'}
                textcolor="#fff"
              />

              <Center>
                <img
                  src="/images/onboarding/licensePaypal.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-app3"
                />
                <img
                  src="/images/onboarding/licensePaypal-mobile2.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-mobile-app3"
                />
              </Center>
            </div>
          )}
        </ContainerBox>
      </div>
    </div>
  )
}

export default withRouter(withAuth(ChooseSubscriptionOnboardingMonthly))
